// Sync policies restrict background caching; they never grant prescribing access.
const DRUG_COLLECTIONS = new Set([
  'drugs', 'drugs_generic_names', 'drugs_advice_dosage', 'drugs_advice_duration',
  'drugs_advice_frequency', 'drugs_advice_when', 'drugs_advice_notes', 'drugs_types',
])

export const INTEL_COLLECTIONS = {
  'drug-info': 'drugs',
  diagnosis: 'diagnosis',
  'health-complaint': 'health_complaints',
  'clinical-diagnosis': 'clinical_diagnoses',
  'clinical-symptom': 'clinical_symptoms',
  investigation: 'investigation',
  'health-observation': 'health_observations',
  'prescription-advice': 'prescription_advice',
  instruction: 'instructions',
}

export function readEmrSyncPayload(response) {
  return response?.data?.data?.['emr-sync-policy'] ?? response?.data?.payload ?? null
}

export function canSyncCollection(config, authorities, collection) {
  return config?.syncEnabled === true &&
    Array.isArray(config.enabledCollections) &&
    config.enabledCollections.includes(collection) &&
    (!DRUG_COLLECTIONS.has(collection) || authorities.includes('ROLE_DOCTOR'))
}
